import { MapTo } from '@adobe/cq-react-editable-components';
import Loadable from '../../../../utils/loadable';
// import { isFuncComp } from '../../../../components/common/Helpers/index.js';

const vdsRedesigntosSectionPage = Loadable(
  () => import('../../containers/web/tosSectionPageVdsRedesign'),
  // isFuncComp() ? import('../../FuncComponnetContainers/tosSectionPageVdsRedesign') : import('../../containers/web/tosSectionPageVdsRedesign'),
);

// const vdsRedesigntosSectionPage = Loadable(() => import('../../containers/web/tosSectionPageVdsRedesign'));
export default MapTo('vcg/components/soe-home/react/vdsRedesigntosSectionPage')(vdsRedesigntosSectionPage);
